module.exports = __webpack_public_path__ + "sl.svg?af9693c48df40e656ba246984fe76fe9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sl.svg
// module id = 936
// module chunks = 27